export var SearchWidgetActions;
(function (SearchWidgetActions) {
    SearchWidgetActions["SET_DATA"] = "SET_DATA";
    SearchWidgetActions["ADD_JOURNEY"] = "ADD_JOURNEY";
    SearchWidgetActions["CHANGE_TRIP_TYPE"] = "CHANGE_TRIP_TYPE";
    SearchWidgetActions["LOCAL_VALIDATION"] = "LOCAL_VALIDATION";
    SearchWidgetActions["CLEAR_VALIDATION"] = "CLEAR_VALIDATION";
    SearchWidgetActions["SET_MODIFY_SEARCH_DATA"] = "SET_MODIFY_SEARCH_DATA";
    SearchWidgetActions["SET_FIELD_CHANGED"] = "SET_FIELD_CHANGED";
})(SearchWidgetActions || (SearchWidgetActions = {}));
export function setSearchData(data) {
    return { type: SearchWidgetActions.SET_DATA, data };
}
export function setTripType(tripType) {
    return { type: SearchWidgetActions.CHANGE_TRIP_TYPE, tripType };
}
// index is used to support multi-city.
export function addJourneyDetails(journeyData, index) {
    return { type: SearchWidgetActions.ADD_JOURNEY, data: journeyData, index };
}
export function validateFields(data) {
    return { type: SearchWidgetActions.LOCAL_VALIDATION, data };
}
export function clearValidations() {
    return { type: SearchWidgetActions.CLEAR_VALIDATION };
}
export function setModifySearchData(data) {
    return { type: SearchWidgetActions.SET_MODIFY_SEARCH_DATA, data };
}
export function setFieldChanged(data) {
    return { type: SearchWidgetActions.SET_FIELD_CHANGED, data };
}
